import axios from "axios";

import {
  CSRF_HEADER_NAME,
  getCsrfToken,
} from "@/auth/csrfClient";
import { BACKEND_URL } from "@/config";


// baseURL, BACKEND_URL'e bağlı: dev'de "" → "/api" (CRA proxy, same-origin),
// prod'da "https://api.belvizyon.com" → "https://api.belvizyon.com/api".
// Aksi halde sayfa belvizyon.com'dayken "/api/..." istekleri Apache SPA
// fallback'ine düşüp index.html (HTML string) döndürür → ".filter is not a function".
const apiClient = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 30000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});


// CSRF interceptor — apiClient instance ayrı olduğu için global interceptor
// (csrfClient.installAxiosCsrfInterceptor) bunun üzerinde çalışmaz; burada
// kendi interceptor'ımızı kuruyoruz. Sprint 2 frontend uygulaması için kritik:
// POST /admin/roles, PUT /admin/roles/{id}/permissions vb. state-changing
// istekler `pb_csrf` cookie + `X-CSRF-Token` header eşleşmesi gerektirir.
const UNSAFE_METHODS = new Set(["post", "put", "patch", "delete"]);

apiClient.interceptors.request.use((config) => {
  try {
    const method = (config.method || "get").toLowerCase();
    if (UNSAFE_METHODS.has(method)) {
      const token = getCsrfToken();
      if (token) {
        config.headers = config.headers || {};
        if (
          !config.headers[CSRF_HEADER_NAME] &&
          !config.headers[CSRF_HEADER_NAME.toLowerCase()]
        ) {
          config.headers[CSRF_HEADER_NAME] = token;
        }
      }
    }
  } catch {
    /* ignore */
  }
  return config;
});


export default apiClient;
